var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pdf-viewer-container text-center"},[_c('embed',{staticClass:"scroll",attrs:{"src":this.url,"id":"pdfFrame","width":"100%","height":"100%"}})])}
var staticRenderFns = []

export { render, staticRenderFns }